
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireGoingTo as ObiWireGoingToElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-going-to.js';
 
 
 

 
 export const ObiWireGoingTo = createComponent({
   react: React,
   tagName: 'obi-wire-going-to',
   elementClass: ObiWireGoingToElement,
   events: {
     
   }
  });
 
 